export default {"src":"/_next/static/media/confirm-jobs.b1459cf4.svg","height":148,"width":282,"blurWidth":0,"blurHeight":0};